import chatInit from '../theme/chat';

const { docReady } = window.phoenix.utils;

docReady(chatInit);
